var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgArrowDown = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 18,
  height: 10,
  viewBox: "0 0 18 10",
  fill: "none",
  ref: svgRef
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M9 10C9.34576 10 9.64068 9.87217 9.90508 9.60669L17.6644 1.93707C17.8881 1.73058 18 1.45526 18 1.14061C18 0.501475 17.4915 0 16.8203 0C16.4949 0 16.2 0.127827 15.9763 0.34415L9 7.25664L2.02373 0.34415C1.78983 0.127827 1.49492 0 1.16949 0C0.508475 0 0 0.501475 0 1.14061C0 1.45526 0.111864 1.73058 0.335593 1.93707L8.09492 9.60669C8.35932 9.87217 8.65424 9.99017 9 10Z",
  fill: "#757E79"
})));

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgArrowDown, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/arrow-down.ddc835fe.svg";
export { ForwardRef as ReactComponent };